import React, { Component } from 'react';
import i18n from "i18next";

class RejectComponents extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    const { harcirahId, changeValue } = this.props;

    changeValue({
      harcirahId,
    });
  }

  onChange(e) {
    const { changeValue } = this.props;

    changeValue({
      description: e.target.value,
    });
  }

  render() {
    return (
      <div className="content table-responsive table-full-width">
        <table className="table table-hover table-bordered">
          <tbody>
            <tr>
              <td>
                {i18n.t("explanation")}:
                {' '}
              </td>
              <td>
                <textarea
                  placeholder="Lütfen açıklama giriniz."
                    // eslint-disable-next-line react/no-this-in-sfc
                  onChange={this.onChange}
                  style={{ width: '100%', height: '120px', resize: 'none' }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default RejectComponents;



// WEBPACK FOOTER //
// ./src/components/actions/reject/component/index.js